export default ({ fill }) => (
  /**
   * Ícone utilizado para alinhamento do
   * rótulo ao topo da feição
   */
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.1725 0.550781V2.21745H0.505859V0.550781H17.1725ZM4.67253 17.2174H7.17253V3.88411H4.67253V17.2174ZM10.5059 12.2174H13.0059V3.88411H10.5059V12.2174Z"
      fill={fill || '#797E82'}
    />
  </svg>
);
